/** PURE_IMPORTS_START .._.._Observable,.._.._observable_combineLatest PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { combineLatest as combineLatestStatic } from '../../observable/combineLatest';
Observable.combineLatest = combineLatestStatic;
//# sourceMappingURL=combineLatest.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/observable/combineLatest.js
// module id = ./node_modules/rxjs/_esm5/add/observable/combineLatest.js
// module chunks = vendor